export const searchCardInputs = [
    {
        label: "승인",
        key: "approvalPhase",
        type: "auto",
        col: "12",
        sm: "4",
        lg: "3",
        value: "All",
        list: ["All", "미확인", "미승인", "승인", "반려"],
    },
    {
        label: "프로젝트 코드",
        key: "projectCode",
        col: "12",
        sm: "4",
        lg: "3",
        value: "",
    },
    {
        label: "사내 견적번호",
        key: "inhouseBidNumber",
        col: "12",
        sm: "4",
        lg: "3",
        value: "",
    },
    {
        label: "기업별 입찰번호",
        key: "companyBidNumber",
        col: "12",
        sm: "4",
        lg: "3",
        value: "",
    },
    {
        label: "업체명",
        key: "companyName",
        col: "12",
        sm: "4",
        lg: "3",
        value: "",
    },
    {
        label: "발행일",
        key: "issueDate",
        type: "dateRange",
        range: true,
        value: [],
        col: "12",
        sm: "4",
        lg: "3",
    },
];
